var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBowvalley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208.316,
    height: 73.713,
    viewBox: "0 0 208.316 73.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#031a62;}.b{fill:#ff8700;}.c{fill:#6a4cd7;}.d{fill:#00a3ff;}.e{fill:#ff003a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140.856 -37.001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M233.879,456.284H203.165v9.209l30.714,12.289,30.709-12.289v-9.209Z",
    transform: "translate(-62.309 -367.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M203.165,282.047h30.714V251.333H203.165Zm15.358-3.841a11.523,11.523,0,1,1,11.515-11.53v0a11.518,11.518,0,0,1-11.507,11.527Z",
    transform: "translate(-62.309 -214.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M323.722,282.048h30.714V251.334H323.722Zm3.587-15.541a16.6,16.6,0,0,0,11.581-11.284.076.076,0,0,1,.074-.058h.216a.081.081,0,0,1,.076.058,16.592,16.592,0,0,0,11.556,11.284.078.078,0,0,1,.056.073v.229a.068.068,0,0,1-.056.069,16.542,16.542,0,0,0-11.556,11.289.079.079,0,0,1-.076.058h-.226a.074.074,0,0,1-.074-.058,16.615,16.615,0,0,0-11.555-11.289.069.069,0,0,1-.058-.069v-.229a.081.081,0,0,1,.043-.073",
    transform: "translate(-152.15 -214.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M203.165,393.392h0v-21.5h30.714Z",
    transform: "translate(-62.309 -304.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M323.723,393.392l15.31-10.719a.067.067,0,0,1,.089,0l15.315,10.719v-21.5H323.723Z",
    transform: "translate(-152.152 -304.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M492.952,290.257h-8.3V272.443h8.022c3.628,0,5.782,1.807,5.782,4.62a4.029,4.029,0,0,1-3.019,4.059,4.312,4.312,0,0,1,3.428,4.292c0,2.946-2.157,4.843-5.909,4.843m-1.121-14.336h-2.844v3.76h2.839c1.421,0,2.212-.626,2.212-1.88s-.786-1.88-2.207-1.88m.307,6.893H489v3.93h3.2c1.446,0,2.283-.627,2.283-1.926s-.9-1.992-2.344-1.992Z",
    transform: "translate(-272.08 -230.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M553.66,300.565a7.286,7.286,0,1,1,7.441-7.288c0,4.49-3.272,7.288-7.441,7.288m0-3.76c1.548,0,3-1.142,3-3.529s-1.423-3.526-2.946-3.526-2.945,1.114-2.945,3.526,1.322,3.529,2.895,3.529",
    transform: "translate(-318.088 -240.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M606.074,286.783h4.335l2.007,10.127,2.387-10.127h4.592l2.413,10.077,1.981-10.077h4.085l-3.836,14.161h-4.792l-2.238-9.186-2.331,9.186H609.9Z",
    transform: "translate(-362.568 -240.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M727.425,272.443h4.609l-6.342,17.814h-5.429l-6.317-17.814h4.617l4.419,13.446Z",
    transform: "translate(-442.959 -230.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M785.654,285.976a4.941,4.941,0,0,1,4.386,2.207v-2.007h4.335v14.161h-4.335v-2.012a5.008,5.008,0,0,1-4.386,2.213c-3.453,0-6.215-2.844-6.215-7.312s2.74-7.25,6.215-7.25m1.253,3.76a3.153,3.153,0,0,0-3.095,3.478c0,2.255,1.466,3.526,3.095,3.526a3.178,3.178,0,0,0,3.1-3.5c0-2.248-1.416-3.483-3.075-3.483Z",
    transform: "translate(-491.768 -240.145)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.343,
    height: 18.798,
    transform: "translate(305.191 41.416)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.333,
    height: 18.798,
    transform: "translate(312.528 41.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M908.933,300.565c-4.16,0-7.154-2.79-7.154-7.288S904.725,286,908.933,286a6.636,6.636,0,0,1,7.055,7.055,10.916,10.916,0,0,1-.073,1.253H906.1a2.607,2.607,0,0,0,2.686,2.72,2.284,2.284,0,0,0,2.256-1.373h4.619a6.624,6.624,0,0,1-6.726,4.914m-2.821-8.653h5.426a2.447,2.447,0,0,0-2.661-2.438,2.684,2.684,0,0,0-2.765,2.438",
    transform: "translate(-582.939 -240.164)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M969.124,286.783h4.693L964.938,307.7h-4.668l3.25-7.212-5.777-13.676h4.843l3.275,8.859Z",
    transform: "translate(-624.645 -240.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M493.7,374.143a8.654,8.654,0,0,1,8.829,6.522h-5.013a4.106,4.106,0,0,0-3.907-2.387c-2.791,0-4.693,2.068-4.693,5.358s1.9,5.351,4.693,5.351a4.1,4.1,0,0,0,3.9-2.38h5.013c-1.061,4.028-4.386,6.492-8.828,6.492-5.482,0-9.356-3.9-9.356-9.463s3.884-9.493,9.366-9.493",
    transform: "translate(-271.846 -305.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M569,405.929a7.285,7.285,0,1,1,7.408-7.28c0,4.5-3.24,7.28-7.408,7.28m0-3.76c1.555,0,3-1.147,3-3.529s-1.415-3.526-2.938-3.526-2.945,1.114-2.945,3.526,1.314,3.534,2.887,3.534Z",
    transform: "translate(-329.496 -318.686)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.341,
    height: 18.897,
    transform: "translate(248.91 68.145)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 4.343,
    height: 18.897,
    transform: "translate(256.078 68.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M687.351,405.929c-4.168,0-7.156-2.791-7.156-7.281s2.94-7.289,7.156-7.289a6.634,6.634,0,0,1,7.055,7.055,9.9,9.9,0,0,1-.08,1.253h-9.818a2.607,2.607,0,0,0,2.687,2.715,2.313,2.313,0,0,0,2.264-1.372h4.617a6.622,6.622,0,0,1-6.723,4.919m-2.82-8.654h5.434a2.452,2.452,0,0,0-2.663-2.438,2.686,2.686,0,0,0-2.771,2.438",
    transform: "translate(-417.807 -318.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M748.17,391.337a4.909,4.909,0,0,1,4.386,2.212v-2h4.335v14.123c0,3.759-2.179,7-7.08,7-4.212,0-6.954-2.131-7.332-5.508h4.287a2.672,2.672,0,0,0,2.844,1.756c1.648,0,2.945-.865,2.945-3.252v-1.994a5.021,5.021,0,0,1-4.386,2.233c-3.478,0-6.266-2.846-6.266-7.314s2.787-7.256,6.266-7.256m1.253,3.76a3.517,3.517,0,0,0,0,6.992c1.662,0,3.1-1.253,3.1-3.5s-1.446-3.478-3.077-3.478Z",
    transform: "translate(-463.795 -318.662)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M813.646,405.929c-4.161,0-7.157-2.791-7.157-7.281s2.945-7.289,7.157-7.289a6.641,6.641,0,0,1,7.06,7.055,11.522,11.522,0,0,1-.076,1.253h-9.818a2.6,2.6,0,0,0,2.686,2.715,2.3,2.3,0,0,0,2.256-1.372h4.624a6.61,6.61,0,0,1-6.732,4.919m-2.813-8.654h5.424a2.447,2.447,0,0,0-2.661-2.438,2.679,2.679,0,0,0-2.763,2.438",
    transform: "translate(-511.926 -318.684)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowvalley);
export default __webpack_public_path__ + "static/media/bowvalley.6112f9f905870e16d3a16cba2430a6d9.svg";
export { ForwardRef as ReactComponent };